<template>
    <ElButton class="green" v-if="!isStart" @click="handlStart" link>
        {{ isRetry ? endText : startText }}
    </ElButton>
    <ElButton class="green" v-else link>
        {{second_text}}
    </ElButton>
</template>
<script>
import { vPassword, vMobile, validateIDCard } from '@/utils/validate'
import { sendSmsApi } from '@/http/api.js'
export default {
  props:{
    // 倒计时总秒数
    seconds: {
        type: Number,
        default: 60
    },
    // 尚未开始时提示
    startText: {
        type: String,
        default: '获取验证码'
    },
    // 正在倒计时中的提示
    changeText: {
        type: String,
        default: 'x秒重新获取'
    },
    // 倒计时结束时的提示
    endText: {
        type: String,
        default: '重新获取'
    },
    // 手机号
    mobile: {
        type: String,
        default: ''
    },
    // 验证码类型
    type: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      isStart:false,
      isRetry:false,
      sendFun:null,
      second:60,
      second_text:''
    }
  },
  methods: {
    sendAdd(){
      this.sendFun = setInterval(()=>{
        
      },1000)
    },
    getChangeText() {
      return this.changeText.replace('x', this.second)
    },
    handleEnd(){
      this.isStart = false
      this.isRetry = true;
    },
    handlStart(){
      
      const regex = /^1[2-9]\d{9}$/;
      if (!this.mobile) {
        return this.$message.error('请输入手机号');
      } else if (!regex.test(this.mobile)) {
        return this.$message.error('手机号码格式不正确');
      }else{
        sendSmsApi({mobile:this.mobile, event: this.type}).then(res=>{
          this.$message.success('验证码发送成功')
          this.isStart = true;
          this.second_text = this.changeText.replace('x', this.second)
          this.sendFun = setInterval(()=>{
            if(this.second === 0){
              this.handleEnd();
              this.clearSendFun()
            }
            this.second--;
            this.second_text = this.changeText.replace('x', this.second)
          },1000)
        });
      }
    },
    clearSendFun(){
      clearInterval(this.sendFun)
    },
  },
}
</script>
<style lang="scss" scoped>
  .green{color: #2F915D !important;}
</style>
